var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eye",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.615,
    height: 14.374,
    viewBox: "0 0 17.615 14.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M17.072,7.857c-1.138-1.943-3.726-5.2-8.269-5.2S1.672,5.914.534,7.857a3.93,3.93,0,0,0,0,3.97c1.138,1.943,3.726,5.2,8.269,5.2s7.131-3.259,8.269-5.2A3.93,3.93,0,0,0,17.072,7.857Zm-1.247,3.165c-.981,1.666-3.193,4.469-7.022,4.469s-6.041-2.8-7.018-4.469a2.337,2.337,0,0,1,0-2.36C2.762,7,4.974,4.193,8.8,4.193s6.041,2.8,7.018,4.469a2.337,2.337,0,0,1,0,2.36Z",
    transform: "translate(0.004 -2.655)",
    fill: "#111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M10.845,7a3.845,3.845,0,1,0,3.845,3.845A3.845,3.845,0,0,0,10.845,7Zm0,6.153a2.307,2.307,0,1,1,2.307-2.307A2.307,2.307,0,0,1,10.845,13.153Z",
    transform: "translate(-2.038 -3.658)",
    fill: "#111"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.143b2de1f23d949f6b736ae16fbd8678.svg";
export { ForwardRef as ReactComponent };